export interface I18N {
    locale: string;
    dateFormat: string;
}

export const i18n: I18N = {
    locale: "en",
    dateFormat: "dd/MM/yyyy"
};
